/* eslint-disable max-len */
export default {
  frames: {
    ONE: 'https://res.cloudinary.com/dx3h2gobh/image/upload/v1696344152/MicrosoftTeams-image_1_klwefs.png',
    TWO: 'https://res.cloudinary.com/dx3h2gobh/image/upload/v1696344152/MicrosoftTeams-image_2_h4cll1.png',


  },
};
